import { render, staticRenderFns } from "./ordenesUrgencia.vue?vue&type=template&id=6cf90c54&"
import script from "./ordenesUrgencia.vue?vue&type=script&lang=js&"
export * from "./ordenesUrgencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports